export default "__VITE_ASSET__DZT74X7C__"